export const minimumLabelCheckoutGrossEur = 20;

export const minimumLabelCheckoutMessage =
  "Etiket satın alımlarında minimum ödeme tutarı KDV dahil 20 €’dur. Lütfen sepet tutarını artırın.";

export function meetsLabelCheckoutMinimum(grossTotal: number) {
  return Number.isFinite(grossTotal) &&
    Math.round((grossTotal + Number.EPSILON) * 100) >= minimumLabelCheckoutGrossEur * 100;
}
